"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const operatorsToDisplayLogoFor = ['parkman_se'];
const OperatorHeader = ({ menuProps }) => {
    if (!menuProps.organization) {
        return null;
    }
    if (menuProps.currentMode !== 'landlord' && menuProps.currentMode !== 'tenant') {
        return null;
    }
    const operatorId = menuProps.organization.current.operatorId;
    if (!operatorId) {
        return null;
    }
    const showOperatorLogo = operatorsToDisplayLogoFor.includes(operatorId);
    if (!showOperatorLogo) {
        return null;
    }
    return (React.createElement("div", { className: "operator-header" },
        React.createElement("img", { className: "operator-logo", src: `https://selfservice-api-run.autopay.io/organizations/operator/logoWithFallback/${operatorId}.svg`, alt: operatorId })));
};
exports.default = OperatorHeader;
//# sourceMappingURL=OperatorHeader.js.map